var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 98,
    viewBox: "0 0 101 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 47,
    r: 47,
    fill: "#FBE1E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 51,
    r: 45.5,
    stroke: "#1C1C1C",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_44957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.832 41.6667C56.832 44.142 55.8487 46.516 54.0984 48.2663C52.348 50.0167 49.9741 51 47.4987 51C45.0234 51 42.6494 50.0167 40.8991 48.2663C39.1487 46.516 38.1654 44.142 38.1654 41.6667M27.9762 40.2699L26.3429 59.8699C25.992 64.0804 25.8166 66.1857 26.5283 67.8098C27.1536 69.2367 28.2371 70.4142 29.6071 71.1558C31.1665 72 33.2791 72 37.5042 72H57.4932C61.7184 72 63.831 72 65.3903 71.1558C66.7603 70.4142 67.8438 69.2367 68.4691 67.8098C69.1809 66.1857 69.0054 64.0804 68.6545 59.8699L67.0212 40.2699C66.7193 36.6471 66.5684 34.8357 65.7661 33.4647C65.0596 32.2574 64.0077 31.2894 62.7458 30.6856C61.3129 30 59.4953 30 55.8599 30L39.1375 30C35.5022 30 33.6845 30 32.2516 30.6856C30.9898 31.2894 29.9378 32.2574 29.2313 33.4647C28.4291 34.8357 28.2781 36.6471 27.9762 40.2699Z",
    stroke: "#101828",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_44957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(22 26)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartImage);
export default __webpack_public_path__ + "static/media/Cart_Image.04a042cf5e370129746f8ab21c5f75db.svg";
export { ForwardRef as ReactComponent };